export default "__VITE_ASSET__Cs$2WOWz__"